import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Switch, Route, useLocation } from 'react-router-dom'
import { Alert, Spinner, EmptyContainer } from 'lib/ui/components'
import { NoMatch } from 'lib/shared/scenes/NoMatch'
import { useBlog, BlogProvider } from 'hooks/blog'
import { Category } from './scenes/Category'
import { Post } from './scenes/Post'
import { Tag } from './scenes/Tag'

export const Blog = () => {
  const { pathname } = useLocation()
  const { isFirstLoad, isFailure, isFetching } = useBlog()

  if (isFirstLoad || isFetching) {
    return (
      <>
        <EmptyContainer>
          <Spinner />
        </EmptyContainer>
      </>
    )
  }

  if (isFailure && !isFetching) {
    return (
      <>
        <EmptyContainer>
          <Alert>
            <FormattedMessage
              id='app.whoops'
            />
          </Alert>
        </EmptyContainer>
      </>
    )
  }

  return (
    <BlogProvider isSofia>
      <Switch
        key={pathname}
      >
        <Route
          exact
          path='/blog/tag/:slug'
          component={Tag}
        />

        <Route
          exact
          path='/blog/post/:slug'
          component={Post}
        />

        <Route
          exact
          path='/blog'
          component={Category}
        />

        <Route
          component={NoMatch}
        />
      </Switch>
    </BlogProvider>
  )
}
